/**
 * Safari-specific style loader
 * Dynamically loads Safari fixes only when Safari browser is detected
 */

export function loadSafariStyles() {
  // Check if it's Chrome first (Chrome includes "Safari" in its user agent)
  const isChrome = /chrome|chromium|crios/i.test(navigator.userAgent) || 
                   !!window.chrome || 
                   (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime));
  
  if (isChrome) {
    console.log('Chrome browser detected, skipping Safari-specific styles');
    return false;
  }
  
  // More accurate Safari detection (after excluding Chrome)
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
                   /constructor/i.test(window.HTMLElement) ||
                   (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
  
  // Alternative Safari detection using feature detection
  const isSafariByFeature = 'WebkitAppearance' in document.documentElement.style && 
                            !('chrome' in window) && 
                            !('opera' in window);
  
  if (!isSafari && !isSafariByFeature) {
    console.log('Not Safari browser, skipping Safari-specific styles');
    return false;
  }
  
  console.log('Safari browser detected, loading Safari-specific styles');
  
  // Method 1: Add class to body for CSS targeting
  document.body.classList.add('safari-browser');
  
  // Method 2: Inject Safari-specific styles dynamically
  // These styles are from _safari-fixes.scss and _safari-flex-fixes.scss
  const safariStyles = `
    /* Safari-specific fixes - loaded only for Safari */
    
    /* ===== SAFARI FLEXBOX COLUMN DIRECTION FIXES ===== */
    /* Safari has issues with flex: 1 in column direction */
    
    /* Fix for all flex column containers using flex: 1 */
    .safari-browser .tab-container,
    .safari-browser .projects-container,
    .safari-browser .project-details-container,
    .safari-browser .board-view-container,
    .safari-browser .board-content,
    .safari-browser .kanban-wrapper,
    .safari-browser .tab-content,
    .safari-browser .projects-content,
    .safari-browser .content-wrapper {
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
    
    .safari-browser .tab-container[style*="flex-direction: column"],
    .safari-browser .tab-container[style*="flex-direction:column"] {
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
    .safari-browser .tab-container {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      flex-basis: auto !important;
    }
    
    .safari-browser .tab-container > * {
      min-height: 0;
    }
    
    .safari-browser .tab-nav {
      height: auto !important;
      min-height: 48px !important;
      align-items: center !important;
    }
    
    .safari-browser .projects-content {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      height: auto !important;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      flex-basis: auto !important;
    }
    
    .safari-browser .tab-content {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow: hidden;
    }
    
    .safari-browser .tab-content .tab-panel {
      flex: 1 1 auto;
      min-height: 0;
      height: 100%;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    
    /* Fix flex: 1 in column containers */
    .safari-browser [style*="flex-direction: column"] > [style*="flex: 1"],
    .safari-browser [style*="flex-direction:column"] > [style*="flex:1"],
    .safari-browser .flex-column > .flex-1 {
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
    
    /* Fix height: 100% in flex containers */
    .safari-browser [style*="display: flex"][style*="height: 100%"]:not([style*="flex-direction: column"]),
    .safari-browser [style*="display:flex"][style*="height:100%"]:not([style*="flex-direction:column"]) {
      height: auto !important;
      max-height: 100% !important;
    }
    
    /* Tab navigation specific */
    .safari-browser .tab-nav[data-v-07217028] {
      height: auto !important;
      min-height: 48px !important;
    }
    
    /* Board view fixes */
    .safari-browser .board-view-container {
      min-height: 100vh !important;
      min-height: -webkit-fill-available !important;
      display: flex;
      flex-direction: column;
    }
    
    .safari-browser .board-view-container .board-content {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow: hidden;
      flex-basis: auto !important;
    }
    
    .safari-browser .board-view-container .kanban-wrapper {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
    }
    
    /* Projects container fixes */
    .safari-browser .projects-container {
      display: flex !important;
      flex-direction: column !important;
      min-height: 100vh !important;
      min-height: -webkit-fill-available !important;
    }
    
    .safari-browser .projects-container .projects-header {
      flex: 0 0 auto;
    }
    
    .safari-browser .projects-container .projects-content {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      height: auto !important;
    }
    
    /* Project details container fixes */
    .safari-browser .project-details-container {
      min-height: 100vh;
      min-height: -webkit-fill-available;
      display: flex;
      flex-direction: column;
    }
    
    .safari-browser .project-details-container .project-header {
      flex: 0 0 auto;
    }
    
    .safari-browser .project-details-container .tab-container {
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
    
    /* Global Safari flex column fix */
    .safari-browser .flex-column > *,
    .safari-browser [style*="flex-direction: column"] > *,
    .safari-browser [style*="flex-direction:column"] > * {
      flex-shrink: 0;
    }
    
    .safari-browser .flex-column > [style*="flex: 1"],
    .safari-browser .flex-column > [style*="flex:1"],
    .safari-browser [style*="flex-direction: column"] > [style*="flex: 1"],
    .safari-browser [style*="flex-direction:column"] > [style*="flex:1"] {
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
    
    /* Fix for flex: 1 elements */
    .safari-browser [style*="flex: 1"]:not([style*="flex: 1 1"]),
    .safari-browser [style*="flex:1"]:not([style*="flex:1 1"]),
    .safari-browser .flex-1 {
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
    
    /* Fix for height: 100% in flex containers */
    .safari-browser .flex > [style*="height: 100%"],
    .safari-browser .flex > [style*="height:100%"],
    .safari-browser [style*="display: flex"] > [style*="height: 100%"],
    .safari-browser [style*="display:flex"] > [style*="height:100%"] {
      height: auto !important;
      flex: 1 1 auto !important;
      min-height: 0 !important;
    }
    
    /* Height calculation fixes */
    .safari-browser .h-100,
    .safari-browser [style*="height: 100vh"],
    .safari-browser [style*="height:100vh"],
    .safari-browser [style*="height: calc(100vh"],
    .safari-browser [style*="height:calc(100vh"] {
      height: auto !important;
      min-height: 100vh !important;
      min-height: -webkit-fill-available !important;
    }
    
    /* Fix for any flex container with height: 100% */
    .safari-browser [style*="display: flex"][style*="height: 100%"],
    .safari-browser [style*="display:flex"][style*="height:100%"],
    .safari-browser .flex[style*="height: 100%"],
    .safari-browser .d-flex[style*="height: 100%"] {
      height: auto !important;
      min-height: 100%;
    }
    
    /* Specific Vue component scoped styles fix */
    .safari-browser [data-v-07217028].tab-container {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      flex-basis: auto !important;
    }
    
    /* Smooth scrolling for Safari */
    .safari-browser .projects-content,
    .safari-browser .tab-content,
    .safari-browser .kanban-wrapper,
    .safari-browser .scrollable,
    .safari-browser .custom-scrollbar,
    .safari-browser .kanban-column,
    .safari-browser .task-list {
      -webkit-overflow-scrolling: touch !important;
      scroll-behavior: smooth;
    }
    
    /* Fix sticky positioning */
    .safari-browser .projects-header,
    .safari-browser .board-header,
    .safari-browser .tab-header,
    .safari-browser .sticky-header,
    .safari-browser .sticky-top,
    .safari-browser .sticky-element,
    .safari-browser [class*="sticky"],
    .safari-browser .tabs-header,
    .safari-browser .task-header.sticky,
    .safari-browser .project-header-sticky {
      position: -webkit-sticky !important;
      position: sticky !important;
      z-index: 10;
    }
    
    /* ===== ADDITIONAL SAFARI COMPATIBILITY FIXES ===== */
    
    /* 1. Flexbox Gap Support (Safari < 14.1) */
    @supports not (gap: 1rem) {
      .safari-browser .task-date,
      .safari-browser .task-action-group,
      .safari-browser .task-header,
      .safari-browser .board-header,
      .safari-browser .filter-group,
      .safari-browser .btn-group,
      .safari-browser .tab-nav {
        gap: 0 !important;
      }
      
      .safari-browser .task-date > * + *,
      .safari-browser .task-action-group > * + *,
      .safari-browser .task-header > * + *,
      .safari-browser .board-header > * + *,
      .safari-browser .filter-group > * + *,
      .safari-browser .btn-group > * + * {
        margin-left: 0.5rem;
      }
      
      .safari-browser .tab-nav > * + * {
        margin-left: 2rem;
      }
      
      .safari-browser [style*="display: flex"][style*="gap:"] > * + *,
      .safari-browser [style*="display:flex"][style*="gap:"] > * + * {
        margin-left: 0.5rem;
      }
    }
    
    /* 2. Line Clamp Support */
    .safari-browser .task-title,
    .safari-browser .task-description,
    .safari-browser .truncate-lines,
    .safari-browser [class*="line-clamp"] {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    /* 3. Grid Gap Fallback */
    @supports not (gap: 1rem) {
      .safari-browser .grid-container > *,
      .safari-browser [style*="display: grid"] > *,
      .safari-browser [style*="display:grid"] > * {
        margin: 0.5rem;
      }
    }
    
    /* 4. Backdrop Filter Support */
    .safari-browser .modal-backdrop,
    .safari-browser .overlay,
    .safari-browser .blur-background {
      -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);
    }
    
    /* 5. Transform 3D Acceleration */
    .safari-browser .task-card,
    .safari-browser .draggable,
    .safari-browser .hover-lift,
    .safari-browser .hover-grow,
    .safari-browser .animated {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      will-change: transform;
    }
    
    /* 6. Safari Scrollbar Styles */
    .safari-browser ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    
    .safari-browser ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }
    
    .safari-browser ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }
    
    .safari-browser ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    
    /* 7. Flexbox Container Fixes */
    .safari-browser .flex-container,
    .safari-browser .task-container,
    .safari-browser .board-column {
      min-height: 0;
    }
    
    .safari-browser .flex-container > *,
    .safari-browser .task-container > *,
    .safari-browser .board-column > * {
      flex-shrink: 0;
    }
    
    /* 8. Input and Form Element Fixes */
    .safari-browser input[type="text"],
    .safari-browser input[type="email"],
    .safari-browser input[type="search"],
    .safari-browser select,
    .safari-browser textarea {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-radius: 4px;
    }
    
    .safari-browser input[type="date"],
    .safari-browser input[type="time"],
    .safari-browser input[type="datetime-local"] {
      -webkit-appearance: none;
      appearance: none;
      min-height: 38px;
    }
    
    /* 9. Color Input Fixes */
    .safari-browser input[type="color"] {
      -webkit-appearance: none;
      appearance: none;
      border: none;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    
    .safari-browser input[type="color"]::-webkit-color-swatch-wrapper {
      padding: 0;
    }
    
    .safari-browser input[type="color"]::-webkit-color-swatch {
      border: none;
      border-radius: 4px;
    }
    
    /* 10. Safari Mobile Specific Fixes */
    @supports (-webkit-touch-callout: none) {
      .safari-browser .task-card,
      .safari-browser .board-column {
        -webkit-tap-highlight-color: transparent;
      }
      
      .safari-browser .modal-content,
      .safari-browser .scrollable-container {
        -webkit-overflow-scrolling: touch;
      }
      
      .safari-browser .fixed-element {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
      }
    }
    
    /* 11. Focus Outline Fix */
    .safari-browser button:focus,
    .safari-browser a:focus,
    .safari-browser input:focus,
    .safari-browser select:focus,
    .safari-browser textarea:focus {
      outline: 2px solid var(--primary-color, #667EEA);
      outline-offset: 2px;
    }
    
    .safari-browser button:focus-visible,
    .safari-browser a:focus-visible,
    .safari-browser input:focus-visible {
      outline: 2px solid var(--primary-color, #667EEA);
      outline-offset: 2px;
    }
    
    /* 12. Clip Path Support */
    .safari-browser .clipped,
    .safari-browser .avatar-mask {
      -webkit-clip-path: circle(50%);
      clip-path: circle(50%);
    }
    
    /* 13. Grid Auto-Fit Fallback */
    @supports not (grid-template-columns: repeat(auto-fit, minmax(250px, 1fr))) {
      .safari-browser .grid-auto-fit {
        display: flex;
        flex-wrap: wrap;
      }
      
      .safari-browser .grid-auto-fit > * {
        flex: 1 1 250px;
        margin: 0.5rem;
      }
    }
    
    /* 14. Button Styling Reset */
    .safari-browser button,
    .safari-browser .btn,
    .safari-browser [role="button"] {
      -webkit-appearance: none;
      appearance: none;
      -webkit-user-select: none;
      user-select: none;
      -webkit-touch-callout: none;
    }
    
    /* 15. Modal and Overlay Fixes */
    .safari-browser .modal,
    .safari-browser .modal-backdrop {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-perspective: 1000px;
      perspective: 1000px;
    }
    
    /* 16. Text Rendering */
    .safari-browser body,
    .safari-browser .task-content {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
    }
    
    /* 17. Box Shadow Performance */
    .safari-browser .shadow,
    .safari-browser .card,
    .safari-browser .task-card {
      -webkit-box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }
  `;
  
  // Create and inject style element
  const styleElement = document.createElement('style');
  styleElement.id = 'safari-specific-styles';
  styleElement.textContent = safariStyles;
  document.head.appendChild(styleElement);
  
  // Method 3: Load external Safari CSS file (if you prefer separate file)
  // const link = document.createElement('link');
  // link.rel = 'stylesheet';
  // link.href = '/css/safari-fixes.css';
  // link.id = 'safari-fixes-stylesheet';
  // document.head.appendChild(link);
  
  return true;
}

// Export Safari detection function for reuse
export function isSafariBrowser() {
  // Check if it's Chrome first (Chrome includes "Safari" in its user agent)
  const isChrome = /chrome|chromium|crios/i.test(navigator.userAgent) || 
                   !!window.chrome || 
                   (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime));
  
  if (isChrome) {
    return false; // Definitely not Safari if it's Chrome
  }
  
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
                   /constructor/i.test(window.HTMLElement) ||
                   (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
  
  const isSafariByFeature = 'WebkitAppearance' in document.documentElement.style && 
                            !('chrome' in window) && 
                            !('opera' in window);
  
  return isSafari || isSafariByFeature;
}